import React, { Component } from 'react';
import {
    BrowserRouter as Router,
    Switch,
    Route,
    Redirect
} from "react-router-dom";

import { Home } from './pages/home/Home';
import { BuildingPage } from './pages/building-page/BuildingPage';

import './App.scss';

export class App extends Component {
    render() {
        return <Router basename={process.env.REACT_APP_BASEHREF}>
            <Switch>
                <Route path="/indicadores">
                    <BuildingPage />
                </Route>
                <Route path="/">
                    <Home />
                </Route>
                <Route path="*">
                    <Redirect to="/" />
                </Route>
            </Switch>
        </Router>;
    }
}